/* eslint-disable linebreak-style */
export const StyledPreviewContainerExplore = {
  height: '210px',
  width: '135px',
  mt: '15px',

  '@media (min-width: 375px)': {
    height: '230px',
    width: '160px'
  },

  '@media (min-width: 450px)': {
    height: '240px',
    width: '170px',
    mt: '10px'
  },

  '@media (min-width: 750px)': {
    mt: '15px'
  }
};

export const StyledCardPreviewImgExplore = {
  height: '50%',
  width: '100%'
}

export const StyledPreviewContentExplore = {
  m: 0,
  p: 0
}

export const StyledCardNameExp = {
  fontSize: '16px',
  px: '6px',
  m: 0,
  ml: '2px',
  mt: '2px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  display: 'block',

  '@media (min-width: 375px)': {
    mt: '6px',
    fontSize: '18px'
  },

  '@media (min-width: 450px)': {
    mt: '8px'
  }
};

export const StyledCardRatExp = {
  fontSize: '14px',
  pl: '6px',
  ml: '2px',

  '@media (min-width: 375px)': {
    mt: '2px',
    py: '4px'
  },

  '@media (min-width: 450px)': {
    mt: '4px'
  }
}